<template>
    <div class="row">
        <div class="col-12">

            <div class="d-flex align-items-center">
                <h6 class="p-0 m-0 mr-2">{{title}}</h6>
                <b-button size="sm" variant="link" v-b-modal.usedHoursDialog class="fa-button">
                    <font-awesome-icon icon="plus-circle" class="icon"/>
                </b-button></div>
        </div>

        <slot></slot>

        <div class="col-12">
            <v-client-table :data="project.usedHours" :columns="columns" :options="options" class="invoice-table">

                <span slot="billId" slot-scope="props" class="text-darker">
                    <span v-if="props.row.billId"><b-badge variant="success">ja</b-badge></span>
                    <span v-if="!props.row.billId"><b-badge variant="danger">nein</b-badge></span>
                </span>
                <span slot="dateFrom" slot-scope="props" class="text-darker"><span v-if="props.row.dateFrom">{{props.row.dateFrom | moment('DD.MM.YYYY')}}</span></span>
                <span slot="dateTo" slot-scope="props" class="text-darker"><span v-if="props.row.dateTo">{{props.row.dateTo | moment('DD.MM.YYYY')}}</span></span>
                <span slot="createDate" slot-scope="props" class="text-darker">{{props.row.createDate | moment('DD.MM.YYYY HH:mm')}}</span>

            </v-client-table>
        </div>

            <div class="col-12">

                <b-modal size="lg"
                         button-size="sm"
                         id="usedHoursDialog" centered title="Stunden"
                         @ok="handleUsedHoursOk"
                         @shown="usedHoursDialogFocus"
                         cancel-title="Abbrechen"
                         ref="usedHoursDialogRef"
                >
                    <div class="container">
                        <div class="row" v-if="project.type === 'hoursamount'">
                            <div class="col"><span class="project-data-title">Stundenkontingent:</span></div><div class="col"><span class="project-data-value">{{project.houramount}}</span></div>
                        </div>
                        <div class="row mb-3" v-if="project.type === 'hoursamount'">
                            <div class="col"><span class="project-data-title">Verbraucht:</span></div><div class="col"><span class="project-data-value">{{usedHours}}</span></div>
                        </div>

                        <form @submit.stop.prevent="handleUsedHoursSubmit" class="default-form">
                            <div class="form-group" v-if="project.type === 'hoursamount'">
                                <label for="dialogUsedHours">Verbrauchte Stunden* (max {{project.houramount - usedHours}})</label>

                                <b-form-input id="dialogUsedHours"
                                              autocomplete="off"
                                              :state="checkState('usedhours-dialog.dialogUsedHours')"
                                              type="text"
                                              v-validate="{between: [0.5, project.houramount - usedHours], required: true, decimal: true}"
                                              name="dialogUsedHours"
                                              v-model.trim="dialogUsedHours.amount"
                                              ref="dialogUsedHours"
                                              class="col-3"
                                              data-vv-scope="usedhours-dialog"
                                ></b-form-input>
                                <span v-show="errors.has('usedhours-dialog.dialogUsedHours')" class="error-message">Bitte eine Zahl zwischen 0.5 und {{project.houramount - usedHours}} eingeben</span>

                            </div>

                            <div class="form-group" v-if="project.type === 'timeandmaterial'">
                                <label for="dialogUsedHours">Verbrauchte Stunden* </label>

                                <b-form-input id="dialogUsedHours"
                                              autocomplete="off"
                                              :state="checkState('usedhours-dialog.dialogUsedHours')"
                                              type="text"
                                              v-validate="{required: true, decimal: true}"
                                              name="dialogUsedHours"
                                              v-model.trim="dialogUsedHours.amount"
                                              ref="dialogUsedHours"
                                              class="col-3"
                                              data-vv-scope="usedhours-dialog"
                                ></b-form-input>
                                <span v-show="errors.has('usedhours-dialog.dialogUsedHours')" class="error-message">Bitte mindestens 0.5 eingeben</span>

                            </div>


                            <div class="form-group">
                                <label for="dialogUsedHoursJira">Jira</label>

                                <b-form-input id="dialogUsedHoursJira"
                                              autocomplete="off"
                                              type="text"
                                              name="dialogUsedHoursJira"
                                              v-model.trim="dialogUsedHours.jira"
                                              class="col-3"
                                ></b-form-input>
                            </div>

                            <div class="form-group form-row">
                                <div class="col-md-6">
                                    <label for="dialogUsedHoursFrom">Von</label>
                                    <div><datepicker id="dialogUsedHoursFrom" input-class="form-control" format="dd.MM.yyyy" :language="languages.de" v-model="dialogUsedHours.dateFrom"
                                                     v-validate="'required'"
                                                     name="dialogUsedHoursFrom"
                                                     data-vv-scope="usedhours-dialog"
                                                     :state="checkState('usedhours-dialog.dialogUsedHoursFrom')"
                                    ></datepicker></div>
                                    <span v-show="errors.has('usedhours-dialog.dialogUsedHoursFrom')" class="error-message">Du musst ein Datum eingeben</span>
                                </div>

                                <div class="col-md-6">
                                    <label for="dialogUsedHoursTo">Bis</label>
                                    <div><datepicker id="dialogUsedHoursFrom" input-class="form-control" format="dd.MM.yyyy"
                                                     :language="languages.de"
                                                     v-model="dialogUsedHours.dateTo"
                                                     v-validate="'required'"
                                                     name="dialogUsedHoursTo"
                                                     data-vv-scope="usedhours-dialog"
                                                     :state="checkState('usedhours-dialog.dialogUsedHoursTo')"
                                    ></datepicker></div>
                                    <span v-show="errors.has('usedhours-dialog.dialogUsedHoursTo')" class="error-message">Du musst ein Datum eingeben</span>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="textAreaDescription">Beschreibung*</label>
                                <b-form-textarea id="dialogUsedHoursDesc"
                                                 v-model="dialogUsedHours.description"
                                                 :rows="4"
                                                 :max-rows="6"
                                                 name="dialogUsedHoursDesc"
                                                 v-validate="'required'"
                                                 :state="checkState('usedhours-dialog.dialogUsedHoursDesc')"
                                                 data-vv-scope="usedhours-dialog"
                                >
                                </b-form-textarea>

                                <span v-show="errors.has('usedhours-dialog.dialogUsedHoursDesc')" class="error-message">Du musst den Aufwand beschreiben</span>
                            </div>
                        </form>
                    </div>
                </b-modal>
            </div>




    </div>
</template>

<script>

    import firestore from "firedb/init";
    import * as lang from "vuejs-datepicker/src/locale";
    import Datepicker from 'vuejs-datepicker';
    import * as Util from 'util/Util';

    export default {
        name: 'BookedHoursEditor',
        components: {
            Datepicker,
        },

        props: {
            title: {
                type: String
            },

            project: {
                type: Object
            }
        },

        data: function() {

            return {
                dialogUsedHours: {},
                columns: this.project.type === 'hoursamount' ? ['amount', 'description', 'jira', 'dateFrom', 'dateTo', 'createDate'] :
                    ['amount', 'description', 'billId', 'jira', 'dateFrom', 'dateTo', 'createDate'],
                languages: lang,

                options: {
                    skin: 'table data-table',
                    filterable: false,

                    headings: {
                        amount: 'Anzahl',
                        description: 'Beschreibung',
                        jira: 'Jira',
                        dateFrom: 'Leistung von',
                        dateTo: 'Leistung bis',
                        createDate: 'Erstellt am',
                        billId: 'Verrechnet'
                    },
                }
            }
        },


        methods: {

            updateProject() {

                firestore.collection('project').doc(this.project.id).set(this.project);


                /*
                set(
                    data
                )
                    .then(result => {

                    }).catch(e => {
                        console.log('LEIDER NEIN');
                    console.error(e);
                    this.saveError = "Update konnte nicht ausgeführt werden."
                });
                */
            },

            usedHoursDialogFocus() {

                this.dialogUsedHours = {};
                this.$validator.reset();
                this.$refs.dialogUsedHours.focus();
            },

            handleUsedHoursOk(e) {

                e.preventDefault();

                this.$validator.validateAll("usedhours-dialog").then(valid => {

                    if (valid) {

                        const newHour = {
                            amount: +this.dialogUsedHours.amount,
                            description: this.dialogUsedHours.description,
                            jira: this.dialogUsedHours.jira || '',
                            createDate: this.$moment().format(),
                            dateFrom: this.dialogUsedHours.dateFrom ? this.$moment(this.dialogUsedHours.dateFrom).format() : '',
                            dateTo: this.dialogUsedHours.dateTo ? this.$moment(this.dialogUsedHours.dateTo).format() : '',
                            billId: null,
                            id: Util.uuidv4()
                        };
                        this.project.usedHours.push(newHour);
                        this.updateProject();
                        this.$refs.usedHoursDialogRef.hide();
                    }
                });

            },

            checkState(fieldName) {

                if (!this.errors.has(fieldName)) {
                    return null;
                }

                return false;
            },

            updateProjectDescription(text) {

                if (text && text.trim() !== '') {
                    this.project.description = text;
                    this.updateProject();
                }

            },
        },

        computed: {
            usedHours: function () {

                return this.project.usedHours.map(data => {
                    return data.amount;
                }).reduce((a, b) => {
                    return a + b;
                }, 0);
            }
        }
    }
</script>

<style scoped>

</style>